export default {
	SET_RESULTS(state, posts) {
		state.addressResults = posts;
	},
	SET_ADDRESS(state, searchValue) {
		state.searchValue = searchValue;
	},
	SET_DIDSEARCH(state, didSearch) {
		state.didSearch = didSearch;
	},
	SET_ISLOADING(state, isLoading) {
		state.isLoading = isLoading;
	},
};
